if (document.getElementById('user-coats')) {
  let placeholderCoats = document.getElementById('prod-info').getAttribute('prod-coats')
  document.getElementById('user-coats').setAttribute('value', placeholderCoats)
}
var found = ''
window.addEventListener('load', function () {
  if (document.getElementById('2-primary')) {
    console.log('2-primary')
    var secondaryArrayParent = document.getElementById('5-array')
    var secondaryArray = secondaryArrayParent.getElementsByClassName('item__array')
  } else {
    console.log('5 primary')
    var secondaryArrayParent = document.getElementById('2-array')
    var secondaryArray = secondaryArrayParent.getElementsByClassName('item__array')
  }
  console.log(secondaryArray)
  var swatches = document.getElementsByClassName('swatchColor')
  console.log('hello')
  console.log(swatches)

  for (var i = 0; i < swatches.length; i++) {
    swatches[i].addEventListener('click', function () {
      console.log('swatch click')
      if (document.getElementById('2-array')) {
        var current = $('.currentSwatch').find('.innerText').text()
        var id = $('.original-selector').find('option')
        console.log(id)
        for (var i = 0; i < id.length; i++) {
          if (id[i].textContent.split(' / ')[0] == current) {
            console.log('checking')
            found = id[i]
            break
          }
        }
        var idCode = $(found).attr('value')
        var optionsArray = $('.swatchColor')
        var activeVariant = optionsArray.index($('.currentSwatch'))
        var secondaryVariant = $(secondaryArray[activeVariant]).attr('variant-id')
        console.log(idCode)
        console.log(optionsArray)
        console.log(activeVariant)
        console.log(secondaryVariant)
        if (document.getElementById('2-primary')) {
          $('#2-item__quantity').attr('name', 'updates[' + idCode + ']')
          $('#2-item__quantity').attr('variant', idCode)
          $('#5-item__quantity').attr('name', 'updates[' + secondaryVariant + ']')
          $('#5-item__quantity').attr('variant', secondaryVariant)
        } else {
          $('#5-item__quantity').attr('name', 'updates[' + idCode + ']')
          $('#5-item__quantity').attr('variant', idCode)
          $('#2-item__quantity').attr('name', 'updates[' + secondaryVariant + ']')
          $('#2-item__quantity').attr('variant', secondaryVariant)
        }
      }
    })
  }
})

function toggleCalculatorEpoxy() {
  const wrap = $('#area-calculator__wrap');

  if (wrap.is(':visible')) {
    wrap.stop().slideUp(500, function() {
      $(this).fadeOut(500);
    });
  } else {
    wrap.stop().fadeIn(500, function() {
      $(this).slideDown(500);
    });
  }
  let description = document.getElementById('area-calculator-description')
  if (description.classList.contains('mobile-description__display')) {
    $('#area-calculator__wrap').toggleClass('show')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()
    $('#area-calculator-description').toggleClass('mobile-description__display')
  } else {
    $('#area-calculator__wrap').toggleClass('show')
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#button-main').toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()

    var left = $('#area-calculator-description').css('left')
    if ($('#area-calculator-description').attr('show') == 'no') {
      $('#area-calculator-description').attr('show', 'yes')
      setTimeout(function () {
        $('#area-calculator-description').toggle('fade')
        $('#area-calculator-description').animate(
          {
            left: '-=100%',
            right: '0%',
          },
          500,
        )
      }, 500)
    } else {
      $('#area-calculator-description').toggle('fade')
      $('#area-calculator-description').attr('show', 'no')
      setTimeout(function () {
        $('#area-calculator-description').css('left', '0px')
      }, 500)
    }
  }
}

function toggleCalculatorMobileEpoxy() {
  var now = new Date().getTime()
  var day = 1000 * 60 * 60 * 24
  var closeTimeOut = 5 * (60 * 60 * 1000)

  $('#area-calculator__wrap').toggleClass('show')
  $('#button-main').toggle()
  $('#option-size').toggle()
  $("[for='option-size']").toggle()
  $('#quantity-selector').toggle()
  $('.quantity-label').toggle()
  $('.quantity-wrapper').toggle()
  $('#area-calculator-description').toggleClass('mobile-description__display')

  if (now - localStorage.getItem('date') >= closeTimeOut) {
    localStorage.setItem('calculatorDescription', '0')
  }
  if (localStorage.calculatorDescription != '1') {
    $('#area-calculator-description').css('display', 'block')
    $('.mobile-description__close').css('display', 'block')
    localStorage.setItem('calculatorDescription', '0')
  }
}

function toggleCalculator() {
  if (document.getElementById('prod-info').getAttribute('volume') == '') {
    $('#calculator__wrap').toggleClass('show')
    $('#calculator__wrap').toggle('fade')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()
  } else {
    $('#area-calculator__wrap').toggleClass('show')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()
  }
}

function toggleCalculatorDescription() {
  let description = document.getElementById('calculator-description')
  if (description.classList.contains('mobile-description__display')) {
    $('#calculator__wrap').toggleClass('show')
    $('#calculator__wrap').toggle('fade')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('#calculator-description').toggleClass('mobile-description__display')
  } else {
    $('#calculator__wrap').toggleClass('show')
    $('#calculator__wrap').toggle('fade')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()

    var left = $('#calculator-description').css('left')
    if ($('#calculator-description').attr('show') == 'no') {
      $('#calculator-description').attr('show', 'yes')
      setTimeout(function () {
        $('#calculator-description').toggle('fade')
        $('#calculator-description').animate(
          {
            left: '-=100%',
            right: '0%',
          },
          500,
        )
      }, 500)
    } else {
      $('#calculator-description').toggle('fade')
      $('#calculator-description').attr('show', 'no')
      setTimeout(function () {
        $('#calculator-description').css('left', '0px')
      }, 500)
    }
  }
}
function toggleCalculatorMobile() {
  const wrap = $('#area-calculator__wrap');
  if (wrap.is(':visible')) {
    wrap.fadeOut(500);
  } else {
    wrap.fadeIn(500);
  }
  if (document.getElementById('prod-info').getAttribute('volume') == '') {
    $('#volume-calculator__wrap').toggleClass('show')
    $('#volume-calculator__wrap').toggle('fade')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()
  } else {
    $('#area-calculator__wrap').toggleClass('show')
    $('#button-main').toggle()
    $('#option-size').toggle()
    $("[for='option-size']").toggle()
    $('#quantity-selector').toggle()
    $('.quantity-label').toggle()
    $('.quantity-wrapper').toggle()
  }
}

function toggleCalculatorMobileDescription() {
  var now = new Date().getTime()
  var day = 1000 * 60 * 60 * 24
  var closeTimeOut = 5 * (60 * 60 * 1000)

  $('#calculator__wrap').toggleClass('show')
  $('#calculator__wrap').toggle('fade')
  $('#button-main').toggle()
  $('#option-size').toggle()
  $("[for='option-size']").toggle()
  $('#quantity-selector').toggle()
  $('.quantity-label').toggle()
  $('.quantity-wrapper').toggle()
  $('#calculator-description').toggleClass('mobile-description__display')

  if (now - localStorage.getItem('date') >= closeTimeOut) {
    localStorage.setItem('calculatorDescription', '0')
  }
  if (localStorage.calculatorDescription != '1') {
    $('#area-calculator-description').css('display', 'block')
    $('.mobile-description__close').css('display', 'block')
    localStorage.setItem('calculatorDescription', '0')
  }
}
function toggleMobileDescription() {
  if (localStorage.calculatorDescription != '1') {
    var date = new Date().getTime()
    localStorage.calculatorDescription = '1'
    localStorage.setItem('date', date)
  }
  $('#area-calculator-description').toggle()
  $('.mobile-description__close').toggle()
}

function removeRecommended() {
  document.getElementById('recommended-coats').style.display = 'none'
}
function areaCheck(that) {
  if (that.value == 'no') {
    $('#width-length').fadeIn(500)
    document.getElementById('width-length').style.display = 'flex'
    $('#area-input').prop('disabled', true)
    // $('#area-input').fadeOut(500);
  } else {
    $('#width-length').fadeOut(500)
    $('#area-input').prop('disabled', false)
    // $('#area-input').fadeIn(500);
  }
}

function areaCalculate() {
  var width = +document.getElementById('width').value
  var height = +document.getElementById('length').value
  var area = width * height
  document.getElementById('area-input').value = area
}

function calculateAreaPaint() {
  var userArea = document.getElementById('area-input').value
  var userCoats = document.getElementById('user-coats').value
  var prodArea = document.getElementById('prod-info').getAttribute('prod-area')
  var prodCoats = document.getElementById('prod-info').getAttribute('prod-coats')
  var result = (userArea * userCoats) / prodArea
  var floatLabels = document.getElementsByClassName('calculator__float-label')
  document.getElementById('prod-result').value = +Math.ceil(result)
  document.getElementById('Quantity-template--22480377118998__main').value = +Math.ceil(result)
  for (var i = 0; i < floatLabels.length; i++) {
    floatLabels[i].style.display = 'block'
  }
}

function calculateAreaEpoxy() {
  var userArea = document.getElementById('area-input').value
  var prodCoats = document.getElementById('prod-info').getAttribute('prod-coats')
  var prodArea2 = document
    .getElementById('2-item')
    .querySelector('#prod-info')
    .getAttribute('prod-area')
  var prodArea5 = document
    .getElementById('5-item')
    .querySelector('#prod-info')
    .getAttribute('prod-area')
  var result2 = 0
  var result5 = 0
  var result2Tot = 0
  var result5Tot = 0
  var floatLabels = document.getElementsByClassName('calculator__float-label')

  if (userArea / 10 <= 1) {
    result2 = Math.ceil(userArea / prodArea2)
  } else if (userArea % prodArea5 <= prodArea5 / 2 && userArea % prodArea5 != 0) {
    result5 = Math.floor(userArea / prodArea5)
    result2 = 1
  } else {
    result5 = Math.ceil(userArea / prodArea5)
  }

  result2Tot = result2 * prodCoats
  result5Tot = result5 * prodCoats
  document.getElementById('5-item__quantity').value = +result5Tot
  document.getElementById('2-item__quantity').value = +result2Tot
  document.getElementById('5-result').value = +result5Tot
  document.getElementById('2.5-result').value = +result2Tot
  for (var i = 0; i < floatLabels.length; i++) {
    floatLabels[i].style.display = 'block'
  }
}

function calculatorSubmit(e) {
  let itemOne = $('#2-item__quantity').attr('variant')
  let qtyOne = $('#2-item__quantity').val()
  let itemTwo = $('#5-item__quantity').attr('variant')
  let qtyTwo = $('#5-item__quantity').val()
  jQuery
    .getJSON('/cart.js', function (data) {
      console.log(data)
    })
    .done(function (data) {
      let dataItems = data.items
      console.log(dataItems)

      for (var i = 0; i < dataItems.length; i++) {
        if (dataItems[i].id == itemOne) {
          console.log('item one basket :' + dataItems[i].quantity)
          qtyOne = +dataItems[i].quantity + +qtyOne
          console.log('updated item one:' + qtyOne)
        } else if (dataItems[i].id == itemTwo) {
          console.log('item two basket :' + dataItems[i].quantity)
          qtyTwo = +dataItems[i].quantity + +qtyTwo
          console.log('updated item one:' + qtyTwo)
        }
      }
    })
    .always(function (data) {
      console.log(itemOne)
      console.log(itemTwo)
      console.log(qtyOne)
      console.log(qtyTwo)
      jQuery.post('/cart/update.js', {
        updates: {
          [itemOne]: qtyOne,
          [itemTwo]: qtyTwo,
        },
      })
      setTimeout(function () {
        $(location).attr('href', '/cart')
      }, 100)
    })
}
